"use client";

import { useScrollDirection } from "../hooks/useScrollDirection";


export default function HeaderClient({ children }: { children: React.ReactNode }) {
  const isVisible = useScrollDirection();

  return (
    <header
      className={`sticky top-0 z-[999] w-full py-2 bg-gradient-to-br from-[#2b517d] to-[#1e3e65] transition-transform duration-100 ${
        isVisible ? "translate-y-0" : "-translate-y-full"
      }`}
    >
      {children}
    </header>
  );
}